import { isEmpty } from "lodash";
import { buildPageMeta } from "anvil-analytics/custom_plugins/utils";

export let cachedPageMeta = {};

/**
 * Analytics middleware that adds any known page metadata to `page` and `track` events.
 *
 * Attempts to find the page metadata from the event being fired. If not found, it falls back to the previously used
 * page metadata.
 *
 * For `page` events, we expect to find a `view_data` object in the event data. This view data contains the number of
 * views remaining and gets combined with the other event data.
 *
 */
const pageMetaEnricherPlugin = {
    name: 'page-meta-enricher',
    trackStart: ({payload}) => {
        const {properties} = payload;
        const allEventData = JSON.parse(JSON.stringify(properties));

        const [pageMeta, eventProperties] = buildPageMeta(allEventData);
        if (!isEmpty(pageMeta)) {
            cachedPageMeta = pageMeta;
        }
        // Combine the event properties and the page metadata
        const updatedEventProperties = Object.assign({}, eventProperties, cachedPageMeta);
        // Update the payload with our new properties
        return Object.assign({}, payload, {properties: updatedEventProperties});
    },
    pageStart: ({payload}) => {
        const {properties} = payload;
        const allPageData = JSON.parse(JSON.stringify(properties));
        const {view_data, ...pageData} = allPageData;

        const [pageMeta, eventProperties] = buildPageMeta(pageData);
        if (!isEmpty(pageMeta)) {
            cachedPageMeta = pageMeta;
        }

        // Combine the event properties and the page metadata
        const updatedEventProperties = Object.assign({}, eventProperties, view_data, cachedPageMeta);
        // Update the payload with our new properties
        return Object.assign({}, payload, {properties: updatedEventProperties});
    }
};

export default pageMetaEnricherPlugin;